import React, { useState } from "react";
import {
  Typography,
  Box,
  IconButton,
  Button,
  TextField,
  Paper,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import {
  addRaffle,
  editRaffle,
  deleteRaffle,
  toggleVisibility,
  setEditingRaffle,
  setFilter,
} from "../../Redux/Slices/rafflesSlice";
import { EventManagementStyles } from "../../Styles/styles";
import { Input, Table } from "antd";
import {
  DeleteContentIcon,
  EditContentIcon,
  SearchIcn,
  VisibilityOffIcon,
  VisibilityOnIcon,
} from "../../Svg/icons";

export default function PurchasedRaffle() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const raffles = useSelector((state) => state.raffles.raffles);
  const filter = useSelector((state) => state.raffles.filter);
  const editingRaffle = useSelector((state) => state.raffles.editingRaffle);

  const [newRaffle, setNewRaffle] = useState({
    name: "",
    code: "",
    type: "",
    date: "",
    location: "",
  });

  const handleDeleteRaffle = (id) => {
    dispatch(deleteRaffle(id));
  };

  const handleToggleVisibility = (id) => {
    dispatch(toggleVisibility(id));
  };

  const handleEditRaffle = (raffle) => {
    dispatch(setEditingRaffle(raffle));
    setNewRaffle(raffle);
  };

  const handleFilter = (type) => {
    dispatch(setFilter(type));
  };

  const filteredRaffles = raffles.filter((raffle) => {
    const currentDate = new Date();
    const raffleDate = new Date(raffle.createdon);

    if (filter === "today") {
      return (
        raffleDate.getDate() === currentDate.getDate() &&
        raffleDate.getMonth() === currentDate.getMonth() &&
        raffleDate.getFullYear() === currentDate.getFullYear()
      );
    } else if (filter === "upcoming") {
      return raffleDate > currentDate;
    } else if (filter === "past") {
      return raffleDate < currentDate;
    }
    return true;
  });

  const columns = [
    {
      dataIndex: "title",
      width: 120,
      title: (
        <span
          style={{
            minWidth: "100%",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Title
        </span>
      ),
      key: "title",
      align: "center",
      ellipsis: true,
      render: (text, record) => (
        <div
          style={{ width: "100%", whiteSpace: "nowrap", textAlign: "center" }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "createdon",
      width: 120,
      title: (
        <span
          style={{
            minWidth: "100%",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Created on
        </span>
      ),
      key: "createdon",
      align: "center",
      ellipsis: true,
      render: (text, record) => (
        <div
          style={{ width: "100%", whiteSpace: "nowrap", textAlign: "center" }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "purpose",
      width: 120,
      title: (
        <span
          style={{
            minWidth: "100%",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Purpose
        </span>
      ),
      key: "purpose",
      align: "center",
      ellipsis: true,
      render: (text, record) => (
        <div
          style={{ width: "100%", whiteSpace: "nowrap", textAlign: "center" }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "totalTickets",
      width: 120,
      title: (
        <span
          style={{
            minWidth: "100%",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Booked
        </span>
      ),
      key: "totalTickets",
      align: "center",
      ellipsis: true,
      render: (text, record) => (
        <div
          style={{ width: "100%", whiteSpace: "nowrap", textAlign: "center" }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "ticketPrice",
      width: 120,
      title: (
        <span
          style={{
            minWidth: "100%",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Tickets Price
        </span>
      ),
      key: "ticketPrice",
      align: "center",
      ellipsis: true,
      render: (text, record) => (
        <div
          style={{ width: "100%", whiteSpace: "nowrap", textAlign: "center" }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "monetaryAward",
      width: 120,
      title: (
        <span
          style={{
            minWidth: "100%",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Monetary Awards
        </span>
      ),
      key: "monetaryAward",
      align: "center",
      ellipsis: true,
      render: (text, record) => (
        <div
          style={{ width: "100%", whiteSpace: "nowrap", textAlign: "center" }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "ticketSold",
      width: 120,
      title: (
        <span
          style={{
            minWidth: "100%",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Tickets Sold
        </span>
      ),
      key: "ticketSold",
      align: "center",
      ellipsis: true,
      render: (text, record) => (
        <div
          style={{ width: "100%", whiteSpace: "nowrap", textAlign: "center" }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "earned",
      width: 120,
      title: (
        <span
          style={{
            minWidth: "100%",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Earned
        </span>
      ),
      key: "earned",
      align: "center",
      ellipsis: true,
      render: (text, record) => (
        <div
          style={{ width: "100%", whiteSpace: "nowrap", textAlign: "center" }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "winner",
      width: 120,
      title: (
        <span
          style={{
            minWidth: "100%",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Winner
        </span>
      ),
      key: "winner",
      align: "center",
      ellipsis: true,
      render: (text, record) => (
        <div
          style={{ width: "100%", whiteSpace: "nowrap", textAlign: "center" }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "winningDate",
      width: 120,
      title: (
        <span
          style={{
            minWidth: "100%",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Winning Date
        </span>
      ),
      key: "winningDate",
      align: "center",
      render: (text, record) => (
        <div
          style={{ width: "100%", whiteSpace: "nowrap", textAlign: "center" }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "action",
      width: 120,
      title: (
        <span
          style={{
            minWidth: "100%",
            whiteSpace: "nowrap",
            textAlign: "center",
          }}
        >
          Action
        </span>
      ),
      key: "action",
      align: "center",
      render: (_, record) => (
        <div
          style={{ width: "100%", whiteSpace: "nowrap", textAlign: "center" }}
        >
          <Button>Book Now</Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Grid container md={12} xs={12}>
        <Grid
          container
          sx={{
            display: "flex",
            flexDirection: { md: "row", xs: "column" },
            justifyContent: "space-between",
            p: 1,
          }}
        >
          <Grid item sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={EventManagementStyles.EventTypo1}
            >
              List of Raffles
            </Typography>
            <Input
              size="large"
              prefix={<SearchIcn />}
              placeholder="search by name"
            />
          </Grid>

          <Grid item>
            <Button
              startIcon={<AddIcon sx={EventManagementStyles.IconColor} />}
              onClick={() => navigate("/add-raffle")}
              sx={EventManagementStyles.AddEventBtn}
            >
              Create Raffle
            </Button>
          </Grid>
        </Grid>
        <Grid sx={{ padding: 1 }} md={12}>
          <Box
            sx={{
              height: { xl: "80vh", lg: "108vh", md: "80vh", xs: "80vh" },
            }}
          >
            <Table
              columns={columns}
              scroll={{ y: 550 }}
              dataSource={filteredRaffles.filter((raffle) => raffle.visible)}
              pagination={{ pageSize: 10 }}
              rowKey="id"
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
